module.exports = __webpack_public_path__ + "img/confused-face_973bb31701a0b5ff6227181ad9398480.png";